import React from 'react'
import { BillboardText, Paragraph, colors } from '@fs/zion-ui'
import { NoticeImportant } from '@fs/zion-icon'
import { css } from '@emotion/core'

const messageCss = css`
  color: var(--special-type-color, ${colors.transparent.gray70});
  align-items: center;
  display: flex;
  margin-top: 4px;
`

// Wraps around the status icon before the helpMessage
const statusIconContainer = css`
  padding-inline-end: 8px;
`

const messageTextCss = css`
  flex-grow: 1;
`

// This is copy/pasted from zion-ui's InputBase component. Only use this for file uploads.
// If Zion-UI provides something like this in the future, remove this.
export default function RequiredText({ inputId, children }) {
  return (
    <BillboardText primaryColor={colors.danger60} as="span">
      <span id={`${inputId}_description`} css={messageCss}>
        {/* STATUS ICON */}
        <span css={statusIconContainer} aria-hidden>
          <NoticeImportant size="sm" />
        </span>

        {/* HELP TEXT */}
        <span className="help-message-container" css={messageTextCss}>
          <Paragraph as="span" size="xs">
            {children}
          </Paragraph>
        </span>
      </span>
    </BillboardText>
  )
}
